// extracted by mini-css-extract-plugin
export default {"listItem":"alerts_listItem__qusAc","activeListItem":"alerts_activeListItem__9qRcP","rewardTitle":"alerts_rewardTitle__nTNIs"};